import { render } from "./CoachItem.vue?vue&type=template&id=59b8bc58&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=59b8bc58&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b8bc58"]])

export default __exports__